import { render, staticRenderFns } from "./ModalBody.vue?vue&type=template&id=b25d225c&scoped=true"
import script from "./ModalBody.vue?vue&type=script&lang=js"
export * from "./ModalBody.vue?vue&type=script&lang=js"
import style0 from "./ModalBody.vue?vue&type=style&index=0&id=b25d225c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25d225c",
  null
  
)

export default component.exports